import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";

export default function ConfirmModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const [saving, setSaving] = useState(false)

  const handleYes = async () => {
    if (typeof modal.options?.callMethod === 'function') {
      setSaving(true)
      await modal.options.callMethod();
      setSaving(false)
    }
    if (typeof modal.options?.successCallback === 'function') {
      setSaving(true)
      await modal.options.successCallback();
      setSaving(false)
    }
    dispatch(setModal({ is_active: false }));
  }

  const handleNo = async () => {
    if (typeof modal.options?.closeMethod === 'function') {
      await modal.options.closeMethod();
    }
    dispatch(setModal({ is_active: false }));
  };

  const formatTitle = (title) => {
    if (!title) return '';
    let result = title.replace(/_/g, ' ');
    result = result.charAt(0).toUpperCase() + result.slice(1);
    return result;
  }

  return modal.is_active && modal.type === 'are_you_sure' ? (
    <div className="modal is-active" data-testid="are-you-sure-modal">
      <div className="modal-background"></div>
      <div className="modal-card modal-card-confirmation column is-5">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            {formatTitle(modal.options.title)}
          </p>
          <button className="delete" aria-label="close" onClick={handleNo}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ minHeight: "30px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              <h3>{modal.options.description}</h3>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" data-testid="are-you-sure-modal-no" className="button is-small has-background-grey has-text-white" onClick={handleNo}>No</button>
            <button type="submit" data-testid="are-you-sure-modal-yes" className="button is-danger is-small mx-1" onClick={handleYes} disabled={saving}>{modal.options.actionLabel}</button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
